import i18next from 'i18next'
import 'reflect-metadata'
import {injectable} from 'inversify'
import {makeAutoObservable, runInAction} from 'mobx'

import {TResetPasswordStore} from '@/pages/ResetPassword'
import {PasswordRecoveryRequest} from '@/stores/password-recovery/models'
import {recoverPassword} from '@/stores/password-recovery/fetchers'
import {openErrorNotification} from '@/utils'
import {LoadingState} from '@/types'
import {ROUTES} from '@/router/routes'
import {getRouterStore} from '@/router/utils'
import {storage} from '@/services/storage'
const RESET_PASSWORD_EMAIL_KEY = 'reset_password_email'

@injectable()
export class PasswordRecoveryStore implements TResetPasswordStore {
    constructor() {
        makeAutoObservable(this)
        this.initializeFromStorage()
    }

    public email = ''
    public resetPasswordLoadingState = LoadingState.IDLE

    private initializeFromStorage() {
        const storedEmail = storage.get(RESET_PASSWORD_EMAIL_KEY)
        if (storedEmail && !storage.isEmpty(storedEmail)) {
            this.email = JSON.parse(storedEmail)
        }
    }

    sendInstructions = async (data: PasswordRecoveryRequest) => {
        runInAction(() => {
            this.resetPasswordLoadingState = LoadingState.LOADING
        })

        try {
            const {error} = await recoverPassword(data)

            if (error) {
                runInAction(() => {
                    this.resetPasswordLoadingState = LoadingState.FAILED
                })
                openErrorNotification(error.message)
            } else {
                runInAction(() => {
                    this.email = data.email
                    storage.set(RESET_PASSWORD_EMAIL_KEY, JSON.stringify(data.email))
                    this.resetPasswordLoadingState = LoadingState.DONE
                })
                getRouterStore().push(ROUTES.confirmEmail)
            }
        } catch (error) {
            runInAction(() => {
                this.resetPasswordLoadingState = LoadingState.FAILED
            })
            openErrorNotification(i18next.t('password-recovery.errors.general'))
        }
    }

    navigateToPasswordFailure = (errorMessage: string) => {
        getRouterStore().push(`${ROUTES.resetPasswordFailure}?m=${errorMessage}`)
    }

    clearStoredEmail = () => {
        storage.set(RESET_PASSWORD_EMAIL_KEY, '')
        this.email = ''
    }
}
